import EmailConsentCheckbox from '~/javascripts/components/DonateForm/EmailConsentCheckbox';
import PhoneNumberField from '~/javascripts/components/DonateForm/PhoneNumberField';
import cx from 'classnames';
import store from '~/javascripts/store';
import { Component } from 'react';
import { observer } from 'mobx-react';

const DonorInfoPopoutForm = observer(
  class DonorInfoPopoutForm extends Component {
    render() {
      return (
        <>
          <div className='flex flex-wrap input-wrapper full-name '>
            {store.donateForm.isIndividualAccount ? (
              <>
                <div className='-mt-px md-mt-0 md--ml-px w-full md-w-1/2'>
                  <label className='hidden' htmlFor='name' />
                  <input
                    className='rounded-b-none md-rounded-r-none md-rounded-bl'
                    data-parsley-error-message='First name is required'
                    data-parsley-not-a-credit-card-number
                    id='name'
                    name='name'
                    onChange={(e) => (store.donateForm.name = e.target.value)}
                    placeholder={this.props.namePlaceholder}
                    required={true}
                    type='text'
                    value={store.donateForm.name}
                  />
                </div>
                <div className='-mt-px md-mt-0 md--ml-px w-full md-w-1/2'>
                  <label className='hidden' htmlFor='surname' />
                  <input
                    className='input rounded-t-none md-rounded-l-none md-rounded-tr'
                    data-parsley-error-message='Last name is required'
                    data-parsley-not-a-credit-card-number
                    id='surname'
                    name='surname'
                    onChange={(e) =>
                      (store.donateForm.surname = e.target.value)
                    }
                    placeholder={this.props.surnamePlaceholder}
                    required={true}
                    type='text'
                    value={store.donateForm.surname}
                  />
                </div>
              </>
            ) : (
              <div className='-mt-px md-mt-0 md--ml-px w-full'>
                <label className='hidden' htmlFor='name' />
                <input
                  className='input'
                  data-parsley-error-message='Name is required'
                  data-parsley-not-a-credit-card-number
                  id='name'
                  name='name'
                  onChange={(e) => (store.donateForm.name = e.target.value)}
                  placeholder='Name'
                  required={true}
                  type='text'
                  value={store.donateForm.name}
                />
              </div>
            )}
          </div>

          <div className='input-wrapper'>
            <input
              className={cx('rounded border-grey-40', {
                hidden: store.donateForm.isUserLoggedIn,
              })}
              data-parsley-email-tld=''
              data-parsley-error-message='Please enter a valid email address'
              id='email'
              onChange={(e) => (store.donateForm.email = e.target.value)}
              placeholder='Email'
              required
              type='email'
              value={store.donateForm.email}
            />
          </div>
          <EmailConsentCheckbox />

          {store.donateForm.showPhoneNumberField && <PhoneNumberField />}
        </>
      );
    }
  }
);

export default DonorInfoPopoutForm;
